import React, { useState, useEffect, useCallback } from "react";
import "../../assets/styles/style.css";
import logo from "../../assets/logos/log.jpg";
import refreshIcon from "../../assets/icons/refresh-icon.svg";
import searchIcon from "../../assets/icons/search-icon.svg";
import menuIcon from "../../assets/icons/menu.svg";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useNavigate, useLocation } from "react-router-dom";
import "../../assets/styles/style.css";
import { FaUserCircle } from "react-icons/fa";
import logoutIcon from "../../assets/icons/logout-icon.svg";
import AuthService from "../../services/AuthServices";
import Booking from "../../assets/icons/booking";
import { FaHome } from "react-icons/fa";
import Braiding from "../../assets/icons/braiding";
import { colors } from "../../assets/config/color";
const Header = ({placeholder,isHomePage,onSearch}) => {
  const [isFocused, setIsFocused] = useState(false);
  const [role, setRole] = useState();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const isSmallScreen = useMediaQuery("(max-width: 600px)");
  const location = useLocation();
  const [activeScreen, setActiveScreen] = useState("/");
  useEffect(() => {
    setActiveScreen(location.pathname);
  }, [location.pathname]);

  const navigate = useNavigate();

  const handleLogout = () => {
    AuthService.logout();
    navigate("/");
  };
  const handleSearch = useCallback (() => {
    onSearch(searchTerm);
  },[searchTerm,onSearch]);
  useEffect(() => {
    const userRole = localStorage.getItem("Role");
    setRole(userRole);
  }, []);

  const handleInputFocus = () => {
    setIsFocused(true);
  };

  const handleInputBlur = () => {
    setIsFocused(false);
  };

  const handleRefresh = () => {
    window.location.reload();
  };

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };
  useEffect(() => {
    if (onSearch) {
      handleSearch();
    }
  }, [searchTerm, onSearch,handleSearch]);

  return (
    <div className="header">
      <div className="logo">
        <img src={logo} alt="Logo" width={130} height="50px" />
      </div>

      {
        !isHomePage &&   <div className={`search-bar ${isFocused ? 'focused' : ''}`}>
        <input type="text" placeholder={placeholder}
        onFocus={handleInputFocus}  
        onBlur={handleInputBlur}
        onChange={(e) => (setSearchTerm(e.target.value))}
        style={{ fontSize: isSmallScreen ? '11px' : '16px' ,width:'100%'}}
        />
        <img src={searchIcon} alt="" onClick={handleSearch} />
      </div>
      }

      {isSmallScreen ? (
        <div className="menu-icon" onClick={toggleMenu}>
          <img src={menuIcon} alt="Menu" width={30} />
        </div>
      ) : (
        <div className="icon">
          <div className="icons">
            <img
              src={refreshIcon}
              alt="Refresh"
              width={isSmallScreen ? 20 : 28}
              onClick={handleRefresh}
            />
          </div>
        </div>
      )}

      {isMenuOpen && isSmallScreen && (
        <div className="expandable-menu">
           <MenuItem
        path="/homeUser"
        icon={
          <FaHome
            size={isSmallScreen ? 15 :20}
            style={{
              color: activeScreen === "/homeUser" ? colors.gold : colors.gris,
            }}
          />
        }
        text="myHome"
        active={activeScreen === "/homeUser"}
      />
      <MenuItem
        path="/styles"
        icon={
          <Braiding
          width={isSmallScreen ? 20 :35}
          height={isSmallScreen ? 20 :35}
          fill={activeScreen === "/styles" ? colors.gold : colors.gris}
          />
        }
        text="Styles"
        active={activeScreen === "/styles"}
      />
      <MenuItem
        path="/bookingUser"
        icon={
          <Booking
          width={isSmallScreen ? 15 :24}
          height={isSmallScreen ? 15 :24}
          fill={activeScreen === "/bookingUser" ? colors.gold : colors.gris}
          />
        }
        text="myBookings"
        active={activeScreen === "/bookingUser"}
      />
      <div style={{ marginTop: "auto" }}>
        <div className="item-menu item-menunotfocus photo">
        <FaUserCircle size={35}  color={colors.gris}/>
        </div>
        <div
          className="item-menu item-menunotfocus logout"
          onClick={handleLogout}
        >
          <img src={logoutIcon} alt="" />
          <span>Logout</span>
        </div>
      </div>
          <div className="item-menu item-menunotfocus" onClick={handleRefresh}>
              <img src={refreshIcon} alt="Refresh" width={20} />
            <span>Refresh</span>
          </div>
          <div className="txtLoger">
            {role && (
              <h3 style={{ fontSize: "16px", textAlign: "center" }}>
                {role.charAt(0).toUpperCase() + role.slice(1)}
              </h3>
            )}
          </div>
        </div>
      )}

      {!isSmallScreen && (
        <div className="txtLoger">
          {role && (
            <h3 style={{ fontSize: "22px" }}>
              {role.charAt(0).toUpperCase() + role.slice(1)}
            </h3>
          )}
        </div>
      )}
    </div>
  );
};

export default Header;


const MenuItem = ({ path, icon, text, active }) => {
  const navigate = useNavigate();

  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <div
      className={`item-menu ${active ? "item-menufocus" : "item-menunotfocus"}`}
      onClick={() => handleNavigation(path)}
    >
      {icon}
      <span style={{ color: active ? colors.gold : "" }}>{text}</span>
    </div>
  );
};